import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {DesignServicesModel} from './DesignServicesModel';
import {ProviderModel} from './ProviderModel';
import {UnitsModel} from './UnitsModel';
import {ServiceVariantModel} from './ServiceVariantModel';
import {SizeModel} from './SizeModel';
import { LocationModel } from './LocationModel';

export class ConsuntivoVolumiModel {
  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  srv: string;
  region: RegionModel;
  servicesCountry: string;
  billingCountry: string;
  localCustomer: LocalCustomerModel;
  contractType: ContractTypeModel;
  resourceUnit: ResourcesUnitModel;
  designServices: DesignServicesModel;
  units: UnitsModel;
  shareName: string;
  applicationDescription: string;
  provider: ProviderModel;
  isRecovery: boolean;
  serviceVariant: ServiceVariantModel;
  size: SizeModel;
  numAnnoMeseAcceptance: number;
  ulbStatus: string;
  requestId: number;
  requestDesc: string;
  instanceName: string;
  systemName: string;
  monthlyForecastQuantity: number;
  approverRequestor: string;
  notes: string;
  workflowStatus: string;
  workflowClosed: boolean;
  vol:number;
  actualQuantityFilter: number;
  docType: string;
  location: LocationModel;
  ssru: string;
  subsidary: string;

  constructor(id?: number,
              numAnnoMeseRif?: number,
              srv?: string,
              region?: RegionModel,
              servicesCountry?: string,
              billingCountry?: string,
              localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              contractType?: ContractTypeModel,
              sl1?: DesignServicesModel,
              units?: UnitsModel,
              shareName?: string,
              applicationDescription?: string,
              provider?: ProviderModel,
              isRecovery?: boolean,
              serviceVariant?: ServiceVariantModel,
              size?: SizeModel,
              numAnnoMeseAcceptance?: number,
              ulbStatus?: string,
              requestId?: number,
              requestDesc?: string,
              instanceName?: string,
              systemName?: string,
              monthlyForecastQuantity?: number,
              approverRequestor?: string,
              notes?: string,
              docType?: string,
              location?: LocationModel,
              ssru?: string,
              subsidary?: string,
              vol?:number) {
    this.id = id;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.srv = srv;
    this.region = region;
    this.servicesCountry = servicesCountry;
    this.billingCountry = billingCountry;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.contractType = contractType;
    this.designServices = sl1;
    this.units = units;
    this.shareName = shareName;
    this.applicationDescription = applicationDescription;
    this.provider = provider;
    this.isRecovery = isRecovery;
    this.serviceVariant = serviceVariant;
    this.size = size;
    this.numAnnoMeseAcceptance = numAnnoMeseAcceptance;
    this.ulbStatus = ulbStatus;
    this.requestId = requestId;
    this.requestDesc = requestDesc;
    this.instanceName = instanceName;
    this.systemName = systemName;
    this.monthlyForecastQuantity = monthlyForecastQuantity;
    this.approverRequestor = approverRequestor;
    this.notes = notes;
    this.location = location;
    this.ssru = ssru;
    this.subsidary = subsidary;
    this.vol=vol;
    this.docType=docType;
  }
}

export class ConstuntivoVolumiStorargeModel extends ConsuntivoVolumiModel {
  actualQuantityFilter: number = null;
}

export class ConsuntivoVolumiReportModel extends  ConsuntivoVolumiModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}

export class ConsuntivoVolumiByRefMonthModel extends ConsuntivoVolumiModel {
  numAnnoMeseRifFrom;
  numAnnoMeseRifTo;
}
